import Gtm from '@grebban/gtm';

export default data => {
    Gtm.addDataLayerEvent('consent', {
        email: data.email,
        consent_context: data.context,
        consent_text: data.text,
    });
};
